import { App } from "vue";

const directives = import.meta.glob('./modules/*.ts', { eager: true });

export function setupDirective(app: App<Element>) {
    app.use({
        install: (app: App<Element>) => {
            for (const directive of Object.values<any>(directives)) {
                const { name } = directive.default;
                if (name) app.directive(name, directive.default);
            }
        },
    });
}